import React from 'react'
import type { SelectionI } from '../../types/constants'
import {
    ProductAdBulkActionModal,
    type ProductAdBulkActionModalProps,
} from './ProductAdBulkActionModal'

export type AddAsinsModalProps = Omit<ProductAdBulkActionModalProps, 'identifier'> & {
    selectedValues: SelectionI
}

export const AddAsinsModal = (props: AddAsinsModalProps) => (
    <ProductAdBulkActionModal {...props} identifier="asin" />
)
